const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const apiCall = async (endpoint, method = 'GET', body) => {
  const config = {
    method,
    headers: {
      'Content-Type': 'application/json'
    }
  };

  if (body && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    config.body = JSON.stringify(body);
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const detail = data?.message || 'Request failed';
    const error = new Error(`${response.status} ${response.statusText}: ${detail}`);
    error.status = response.status;
    throw error;
  }

  return data;
};

export const contactAPI = {
  submit: async (payload) => {
    const endpoint = API_BASE_URL.endsWith('/api') || API_BASE_URL.endsWith('/api/')
      ? '/contact'
      : '/api/contact';
    return await apiCall(endpoint, 'POST', payload);
  }
};
